import Request from '@/plugins/request'

export function getWechatNotifyBinds(params) {
  return Request.get('wechat-notify-binds', { params })
}

export function getNotifyTypes() {
  return Request.get('wechat-notify-binds/notify-type')
}

export function createWechatNotifyBind() {
  return Request.get(`wechat-notify-binds/create`)
}

export function storeWechatNotifyBind(data) {
  return Request.post('wechat-notify-binds', data)
}

export function updateWechatNotifyBind(id, data) {
  return Request.put(`wechat-notify-binds/${id}`, data)
}

export function editWechatNotifyBind(id) {
  return Request.get(`wechat-notify-binds/${id}/edit`)
}

export function getAuthorizeUrl() {
  return Request.get(`wechat-notify-binds/get-authorize-url`)
}

export function destroyWechatNotifyBind(id) {
  return Request.delete(`wechat-notify-binds/${id}`)
}
